module.exports = __webpack_public_path__ + "img/PPP.44672e75.svg";